import { Box } from '@mui/material';
import React from 'react';

import DatePicker from '@/components/ui/DatePicker';
import FilterContainer from '@/components/ui/FilterContainer';
import SelectBox from '@/components/ui/SelectBox';
import { ALL_SUPPLIERS, getSupplierDisplayName, SupplierType } from '@/lib/constants/suppliers';

interface ProgramFiltersProps {
  date: Date | null;
  supplier: string;
  onDateChange: (date: Date | null) => void;
  onSupplierChange: (supplier: string) => void;
}

/**
 * Program filter component
 * Provides filtering UI by date and supplier
 */
export const ProgramFilters: React.FC<ProgramFiltersProps> = ({
  date,
  supplier,
  onDateChange,
  onSupplierChange,
}) => {
  // Convert supplier options for SelectBox
  const supplierOptions = ALL_SUPPLIERS.map(supplierType => ({
    value: supplierType,
    label: getSupplierDisplayName(supplierType as SupplierType),
  }));

  return (
    <FilterContainer>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
        <DatePicker
          id="program-date-filter"
          label="日付"
          value={date}
          onChange={onDateChange}
        />

        <SelectBox
          id="program-supplier-filter"
          label="サプライヤー"
          value={supplier}
          options={supplierOptions}
          onChange={onSupplierChange}
        />
      </Box>
    </FilterContainer>
  );
};

export default ProgramFilters;
